import * as React from 'react';

var _circle, _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgWorldChain = function SvgWorldChain(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#fff"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        d: "M90.048 8.081C80.825 2.756 70.841 0 60 0 49.158 0 39.177 2.662 29.952 8.081c-9.222 5.42-16.45 12.646-21.87 21.871C2.661 39.175 0 49.158 0 60s2.662 20.823 8.081 30.048c5.42 9.222 12.646 16.451 21.871 21.871C39.175 117.338 49.158 120 60 120s20.823-2.662 30.048-8.081c9.222-5.42 16.451-12.646 21.871-21.871S120 70.841 120 60c0-10.842-2.662-20.823-8.081-30.048-5.42-9.222-12.646-16.45-21.871-21.87m-26.339 73.6c-6.75 0-12.17-1.903-16.355-5.8-2.852-2.661-4.658-5.895-5.61-9.698h64.661c-.665 5.516-2.282 10.65-4.754 15.5H63.615h.096zM41.84 54.009c.855-3.71 2.757-6.94 5.515-9.605 4.089-3.899 9.605-5.895 16.355-5.895h38.226c2.472 4.85 3.992 9.984 4.564 15.5zM19.492 36.133c4.185-7.226 9.795-12.932 16.927-17.21S51.443 12.552 60 12.552s16.45 2.092 23.581 6.37c3.613 2.187 6.94 4.755 9.794 7.703H63.138q-10.27 0-18.258 4.278c-5.326 2.852-9.508 6.75-12.456 11.79a30.3 30.3 0 0 0-3.993 11.412H13.597c.761-6.371 2.662-12.362 5.895-17.876zm64.09 64.944c-7.133 4.279-15.025 6.371-23.582 6.371s-16.45-2.092-23.581-6.371c-7.132-4.278-12.838-9.984-16.927-17.21a45.9 45.9 0 0 1-5.895-17.592h14.834a30.3 30.3 0 0 0 3.993 11.41c2.948 4.945 7.132 8.94 12.456 11.791q7.987 4.278 18.258 4.279h29.951a48.2 48.2 0 0 1-9.508 7.416v-.096z"
    })));
};

export { SvgWorldChain as ReactComponent };
//# sourceMappingURL=WorldChain.svg.es.js.map
